import { VFC } from "react";

interface Props {
  children?: JSX.Element | JSX.Element[];
}

const StyledTableHeaderRow: VFC<Props> = (props: Props) => {
  return <tr>{props.children}</tr>;
};

export default StyledTableHeaderRow;
